import { PluginFunction } from 'vue';

interface IVirtualKeyboardActions {
    onConfirm: Function;
    onChange: Function;
    onHide: Function;
}

export default {
    install(vue: PluginFunction<{}>) {
        // eslint-disable-next-line
        vue.prototype.showVirtualKeyboard = (e: any, virtualKeyboardActions: IVirtualKeyboardActions) => {
            if (window.SSBT && window.SSBT.VirtualKeyboard) {
                window.SSBT.VirtualKeyboard.show(e, virtualKeyboardActions);
            }
        };
        // eslint-disable-next-line
        vue.prototype.hideVirtualKeyboard = () => {
            if (window.SSBT && window.SSBT.VirtualKeyboard) {
                window.SSBT.VirtualKeyboard.hide();
            }
        };
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/plugins/virtualKeyboard.ts